import React from "react";
import Select from "react-select";
import {Result} from "../../types/Result";
import {sweetalert} from "../../App";
import {isBlank, isOnlyWhitespace} from "../../util/ValidationUtil";
import {buildRow, getBoolSelectOptions, getBoolSelectVal} from "../../util/FormatUtil";
import {isEmptyObject} from "jquery";
import GetField from "../../customfields/GetField";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";
import { getFieldReadOnly, FieldPermissions } from "../../util/RolePermissions";

interface ResultsManagementState{
    selectedResult:Result
    customFieldData?
}
interface ResultsManagementProps{
    selectedResult
    onSubmit?
    pageCustomQuestions?
    userRoles?
    fieldPermissions?: FieldPermissions
}
export class ResultsManagementModal extends React.Component<ResultsManagementProps, ResultsManagementState>{
    public static ID = "servicesmanagement";
    constructor(props) {
        super(props);
        this.state = {
            selectedResult: {
                ID: null,
                // Value: null,
                Analyte_Result: null,
                // Description: null,
                Analyte_Name: null,
                Analyte_ConclusionReport: null,
                EnableHighlighting: null,
                HighlightColor: null,
                HighlightColorLabel: null,
                IsEnabled: null,
                AllowNonStandardResultValue: null,
                CustomFieldData: null,
                Snomed_Code: null
            } as Result
        } as ResultsManagementState
        this.clearFields = this.clearFields.bind(this)
    }

    componentDidMount(): void {
        $(`#${ResultsManagementModal.ID}`).on('shown.bs.modal', function() {
            $(document).off('focusin.modal');
        });
    }

    componentWillReceiveProps(nextProps: Readonly<ResultsManagementProps>, nextContext: any) {
        if(!isEmptyObject(nextProps.selectedResult)){
            let result = nextProps.selectedResult;
            this.setState({
                selectedResult: {
                    ID: result.ID,
                    // Value: result.Value,
                    // Description: result.Description,
                    Analyte_Result: result.Analyte_Result,
                    Analyte_Name: result.Analyte_Name,
                    Analyte_ConclusionReport: result.Analyte_ConclusionReport,
                    EnableHighlighting: result.EnableHighlighting,
                    HighlightColor: result.HighlightColor,
                    HighlightColorLabel: result.HighlightColorLabel,
                    IsEnabled: result.IsEnabled,
                    AllowNonStandardResultValue: result.AllowNonStandardResultValue,
                    CustomFieldData: result.CustomFieldData && JSON.stringify(result.CustomFieldData) !== '{}' ? JSON.parse(result.CustomFieldData) : null,
                    CreatedDate: result.CreatedDate ? result.CreatedDate : new Date(),
                    Snomed_Code: result.Snomed_Code ? result.Snomed_Code : null
                } as Result
            });
       
        }
    }

    clearFields(){
        this.setState({
            selectedResult: {
                ID: null,
                Analyte_Result: null,
                Analyte_Name: null,
                Analyte_ConclusionReport: null,
                EnableHighlighting: null,
                HighlightColor: null,
                HighlightColorLabel: null,
                IsEnabled: null,
                AllowNonStandardResultValue: null,
                CustomFieldData: null,
                Snomed_Code: null
            } as Result
        })
    }

    render(){
        return(
            <div className="modal fade form_modal" id={ResultsManagementModal.ID} tabIndex={-1} role="dialog"
                 aria-labelledby="result_modal_label"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                    <div className="container-fluid">
                        <div className="modal-header">
                            <h5 className="modal-title" id="result_modal_label">Result Management</h5>
                            <button  style={{outline: 'none'}} type="button" onClick={() => this.clearFields()} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {buildRow("Result",
                                <input className={"form-control"}
                                    id="Analyte_Result"
                                    maxLength={50}
                                    readOnly={this.state.selectedResult.ID != null}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"Analyte_Result"}
                                    aria-label="Analyte_Result"
                                    onChange={(e) => {
                                        this.setState((prevState) => ({
                                            selectedResult: {
                                                ...prevState.selectedResult,
                                                Analyte_Result: e.target.value
                                            }
                                        }))
                                    }}
                                    value={this.state.selectedResult.Analyte_Result || ""}
                                />, "Result", true
                            )}
                            {buildRow("Analyte Name",
                                <input
                                    className={"form-control"}
                                    id="Analyte_Name"
                                    maxLength={50}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"Analyte_Name"}
                                    aria-label="Analyte_Name"
                                    onChange={(e) => this.setState((prevState) => ({
                                        selectedResult: {
                                            ...prevState.selectedResult,
                                            Analyte_Name: e.target.value
                                        }
                                    }))}
                                    value={ this.state.selectedResult.Analyte_Name || "" }
                                />, "Analyte Name", true
                            )}
                            {buildRow("Analyte Conclusion Report",
                                <input
                                    className={"form-control"}
                                    id="Analyte_ConclusionReport"
                                    maxLength={1000}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"Analyte_ConclusionReport"}
                                    aria-label="Analyte_ConclusionReport"
                                    onChange={(e) => this.setState((prevState) => ({
                                        selectedResult: {
                                            ...prevState.selectedResult,
                                            Analyte_ConclusionReport: e.target.value
                                        }
                                    }))}
                                    value={ this.state.selectedResult.Analyte_ConclusionReport || "" }
                                />, "Analyte Conclusion Report"
                            )}
                            {buildRow("Is Enabled",
                                <Select
                                isSearchable={true}
                                placeholder={<div className="accessibilityText">Please Select...</div>}
                                noOptionsMessage={() => "No option"}
                                aria-label="Is Enabled?"
                                value={ this.state.selectedResult.ID ? getBoolSelectVal(this.state.selectedResult.IsEnabled):
                                    this.state.selectedResult.IsEnabled === 1 ||  this.state.selectedResult.IsEnabled === 0 ? getBoolSelectVal(this.state.selectedResult.IsEnabled) :
                                    null }
                                onChange={(e) => this.setState((prevState)=>({
                                    selectedResult: {
                                        ...prevState.selectedResult,
                                        IsEnabled: e.value ? 1 : 0
                                    }
                                }))}
                                className={"state_select"}
                                options={getBoolSelectOptions()}
                            />, "Is Enabled", true
                            )}
                            {buildRow("Is Non-Standard Result?",
                                <Select
                                isSearchable={true}
                                placeholder={"Please Select..."}
                                noOptionsMessage={() => "No option"}
                                value={ this.state.selectedResult.ID ? getBoolSelectVal(this.state.selectedResult.AllowNonStandardResultValue):
                                    this.state.selectedResult.AllowNonStandardResultValue === 1 ||  this.state.selectedResult.AllowNonStandardResultValue === 0 ? getBoolSelectVal(this.state.selectedResult.AllowNonStandardResultValue) :
                                    null }
                                onChange={(e) => this.setState((prevState)=>({
                                    selectedResult: {
                                        ...prevState.selectedResult,
                                        AllowNonStandardResultValue: e.value ? 1 : 0
                                    }
                                }))}
                                className={"state_select"}
                                options={getBoolSelectOptions()}
                            />, "Is Non-Standard Result?", true
                            )}
                             {/*Custom Field Data*/}

                             {
                                (this.props.pageCustomQuestions)
                                    ?
                                    <div className="row">
                                        {this.props.pageCustomQuestions.map((val, index) => {
                                            if(val.Options.isActive){
                                                return (
                                                    <div className="col-12">
                                                        <div className="form-group row">
                                                            <GetField
                                                            val={val}
                                                            isRequired={val.Options.isRequired}
                                                            readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)}
                                                            selectedItem={this.state.selectedResult ? this.state.selectedResult : null}
                                                            handleChange={(e) => {
                                                                this.setState({selectedResult: e})
                                                            }}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } 
                                            else {
                                                return <></>
                                            }
                                        })}
                                    </div>
                                    :
                                    <div className="invisible"></div>
                            }
                            {buildRow("Snomed Code",
                                <input
                                    className={"form-control"}
                                    id="Snomed_Code"
                                    maxLength={50}
                                    autoComplete={"off"}
                                    type={"search"}
                                    name={"Snomed_Code"}
                                    aria-label="Snomed_Code"
                                    onChange={(e) => this.setState((prevState) => ({
                                        selectedResult: {
                                            ...prevState.selectedResult,
                                            Snomed_Code: e.target.value
                                        }
                                    }))}
                                    value={this.state.selectedResult.Snomed_Code || ""}
                                />, "Snomed Code",false
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => {
                                if(isBlank(this.state.selectedResult.Analyte_Result) ||
                                    isOnlyWhitespace(this.state.selectedResult.Analyte_Result)
                                ){
                                    return sweetalert.fire("Attention","Analyte Result cannot be empty.", "error")
                                }
                                if(isBlank(this.state.selectedResult.Analyte_Name) || isOnlyWhitespace(this.state.selectedResult.Analyte_Name)){
                                    return sweetalert.fire("Attention", "Analyte Name cannot be empty", "error")
                                }
                                // if(isBlank(this.state.selectedResult.Snomed_Code) ||
                                //     isOnlyWhitespace(this.state.selectedResult.Snomed_Code)
                                // ){
                                //     return sweetalert.fire("Attention","Snomed Code cannot be empty.", "error")
                                // }
                                if( this.state.selectedResult.IsEnabled === null && this.state.selectedResult.ID === null){
                                    return sweetalert.fire("Attention", "Please select a value for Is Enabled", "error")
                                }
                                if( this.state.selectedResult.AllowNonStandardResultValue === null && this.state.selectedResult.ID === null){
                                    return sweetalert.fire("Attention", "Please select a value for Is Non-Standard Result", "error")
                                }
                                let invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedResult.CustomFieldData, this.props.pageCustomQuestions, this.state.selectedResult)

                                if(invalid){
                                    return;
                                }


                                this.props.onSubmit(this.state.selectedResult);
                            }}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}